export const appNameKeysMap = new Map([
    ['app_netatmo', 'Netatmo App'],
    ['app_magellan', 'Magellan App'],
    ['app_security', 'Security App'],
    ['app_velux', 'Velux App'],
    ['app_muller', 'Muller App'],
    ['app_mfh', 'Mfh App'],
    ['app_thermostat_sdbg', 'SDBG App'],
    ['app_thermostat_vaillant', 'Vaillant App'],
]);
